import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Globals } from '../../globals';
import { CurrencyPipe } from '@angular/common';
import { CustomersServices } from '../customers/services';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToastController, LoadingController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';


//interface
interface Invoice {
  UID: string;
  UID_RESTAURANT: string;
  customer: any;
  invoice_confirm: any;
  invoice_number: any;
  list_tickets: any;
  customer_uid: any;
}

interface Ticket {
  UID: string;
  UID_RESTAURANT: string;
}


@Injectable()
export class InvoicesServices {
  public firestore: any;
  invoiceCol: AngularFirestoreCollection<Invoice>;
  invoiceDoc: AngularFirestoreDocument<Invoice>;
  ticketCol: AngularFirestoreCollection<Ticket>;
  ticketDoc: AngularFirestoreDocument<Ticket>;
  invoices: Observable<Invoice[]>;
  list_invoices: Observable<Invoice[]>;
  invoice: any;

  //
  invoice_print: string = 'indv';
  invoice_print_ind_number: any;
  invoice_print_ind_date
  invoice_print_indv_tickets: any;
  invoice_print_indv_ticket_subtotal: any;
  invoice_print_indv_total_ticket: any;
  invoice_print_indv_cus_name: any;
  invoice_print_indv_cus_address: any;
  invoice_print_indv_cus_cif: any;
  invoice_print_indv_ticket_iva: any;
  invoice_print_tips: number = 0;
  invoice_print_indv_taxs: any;
  invoice_payed: boolean;
  invoice_print_indv_rectification: boolean;
  invoice_print_indv_rectified: boolean;
  invoice_print_indv_original_invoice_number: number = 0;

  limit_pages: number;
  page_active: number = 1;

  public customer_selected: any;
  public total_pending: number = 0;

  constructor(public afs: AngularFirestore,
    public globals: Globals,
    public cp: CurrencyPipe,
    public customersServices: CustomersServices,
    public http: HttpClient,
    private toastCtrl: ToastController,
    public translate: TranslateService,
    public loadingCtrl: LoadingController) {
    this.firestore = firebase.firestore();
  }

  async getListInvoices(UID_RESTAURANT) {
    this.invoiceCol = this.afs.collection('invoices', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('invoice_confirm', '==', true)
      .orderBy('created_at', 'desc'));
    this.list_invoices = this.invoiceCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Invoice;
        data.UID = a.payload.doc.id;
        return data;
      });
    });

  }
  no_invoices = true;
  invoices_pending: any = [];
  getInvoicesPending(UID_RESTAURANT) {
    this.no_invoices = true;

    this.invoiceCol = this.afs.collection('invoices', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('invoice_confirm', '==', false).orderBy('customer'));
    this.invoices = this.invoiceCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Invoice;
        data.UID = a.payload.doc.id;
        this.no_invoices = false;
        return data;
      });
    });


    this.invoiceCol.snapshotChanges().subscribe(value => {
      this.invoices_pending = [];
      this.total_pending = 0;
      value.map((a, index) => {
        const data = a.payload.doc.data() as Invoice;
        data.UID = a.payload.doc.id;
        this.invoices_pending.push(data);
        this.total_pending++;
        return data;
      });
    });


  }

  async getInvoice(uid) {

    const restRef = this.firestore.collection('invoices').doc(uid);

    var _num;

    await restRef.get().then(doc => {
      _num = doc.data();
      _num.UID = doc.id;
    });

    return _num

  }


  async getInvoiceNumber(uid) {

    const restRef = this.firestore.collection('restaurants').doc(uid);

    var _num;

    await restRef.get().then(doc => {
      _num = doc.data();
    });

    return _num

  }

  async checkCustomerInvoiceExists(UID_RESTAURANT, UID_CUSTOMER) {
    const invoicesRef = this.firestore.collection('invoices');
    var _state = false;

    await invoicesRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var invoice = doc.data();
          invoice.UID = doc.id;


          if (invoice.customer_uid == UID_CUSTOMER && invoice.invoice_confirm == false) {
            this.invoice = invoice;
            _state = true;
          }

        });
      });
    return _state;
  }


  invoiceUpdateNumber(uid, number) {
    this.afs.collection('restaurants').doc(uid).update({
      number: number,
    });
  }


  async getListTicketsOfInvoice(list_tickets) {
    var _list_tickets = [];

    for (let ticket_uid of list_tickets) {
      if (ticket_uid) {
        const ticketRef = this.firestore.collection('tickets').doc(ticket_uid);

        await ticketRef.get().then(doc => {

          var ticket = doc.data();

          if (ticket) {
            ticket.UID = doc.id;
            _list_tickets.push(ticket);
          }
        });
      }
    }

    return _list_tickets;
  }

  filteredInvoicesActive: boolean = false;
  filteredInvoices: any;
  searchInvoicesNode(value) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredInvoicesActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('filter_string', value.target.value.toLowerCase());

        this.http.post(this.globals.analytics_path + 'filter/invoices', params, {})
          .subscribe(async res => {
            this.filteredInvoices = res;
            this.filteredInvoicesActive = true;
          });
      } else {
        this.filteredInvoicesActive = false;
      }
    }
  }

  pagesInvoices: any;
  //get_invoices_done: boolean = false;
  //list_invoices_array: any;
  first_invoices_name: any;
  invoices_array: any;
  /*async getPagesInvoices(elements_per_page) {
    this.get_invoices_done = false;
    this.filteredInvoicesActive = false;
    this.limit_pages = elements_per_page;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('elements_per_page', elements_per_page);

    await this.http.post(this.globals.analytics_path + 'paginate/invoices', params, {})
      .subscribe(async res => {
        this.pagesInvoices = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        this.list_invoices_array = res['list_invoices'];
        if (this.pagesInvoices != 0) { //Si hay paginas
          this.getListInvoicesNode();
        } else { //Si no hay paginas
          this.get_invoices_done = true;
        }
      });
  }*/
  getListInvoicesNode() {
    this.get_invoices_done = true;
    //Search for first element to start
    this.first_invoices_name = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    this.invoices_array = this.list_invoices_array.slice(this.first_invoices_name, this.first_invoices_name + this.limit_pages);
  }


  /* UNITED FUNC PREPARE AND OPTION (INVOICES)*/

  async prepareAndOption(option, origin, invoice_uid, customer_uid, ticket, invoice_tickets) {

    //CUSTOMER
    var customer_raw = await this.customersServices.getCustomer(customer_uid);
    var _customer = [{
      'name': customer_raw.name,
      'business_name': customer_raw.business_name,
      'business_number': customer_raw.business_number,
      'address': customer_raw.address,
      'email': customer_raw.email,
      'phone': customer_raw.phone,
    }];

    //RESTSAURANT
    var _restaurant = [{
      'company': this.globals.restaurant.company,
      'fiscal_name': this.globals.restaurant.fiscal_name,
      'cif': this.globals.restaurant.cif,
      'address': this.globals.restaurant.address,
      'email': this.globals.restaurant.email,
      'phone': this.globals.restaurant.phone,
      'iban_number': this.globals.restaurant.iban_number,
    }];

    //INVOICES
    var _invoice: any;
    var invoice_raw = await this.getInvoice(invoice_uid);
    _invoice = [{
      'invoice_number': invoice_raw.invoice_number,
      'payed': invoice_raw.payed,
      'date': invoice_raw.created_at.toDate(),
      'total': this.cp.transform(invoice_raw.total, this.globals.user_currency, true, '0.2-2', 'es'),
      'subtotal': this.cp.transform(invoice_raw.subtotal, this.globals.user_currency, true, '0.2-2', 'es'),
      'iva': this.cp.transform(invoice_raw.iva, this.globals.user_currency, true, '0.2-2', 'es'),
      'tax_name': this.globals.user_tax_name,
      'tax_value': this.globals.user_tax,
      'rectification': invoice_raw.rectification || false,
      'rectified': invoice_raw.rectified || false,
      'original_invoice_uid': invoice_raw.original_invoice_uid || '',
      'original_invoice_number': invoice_raw.original_invoice_number || '',
      'UID_RESTAURANT': this.globals.restaurant_uid,
    }];

    //init vars
    var _tickets = [];
    var _ticket;
    var _list_taxes = [];
    var _tips = 0;
    //
    if (origin === 'tpv') {//momento crear desde tpv
      //refund
      var refund_reason = '';
      if (ticket.refund_reason) {
        refund_reason = ticket.refund_reason;
      } else {
        refund_reason = '';
      }
      _ticket = {
        'number': ticket.number + " (" + this.globals.timestampToDate(ticket.date) + ")" + ' ' + refund_reason,
        'amount': this.cp.transform(ticket.amount, this.globals.user_currency, true, '0.2-2', 'es'),
      }
      //tips
      if (ticket.tip) {
        _tips += ticket.tip;
      }
      //taxes
      var taxes_create = this.globals.showIvaProducts(ticket.list);
      _list_taxes = taxes_create.taxs;
      //push ticket
      _tickets.push(_ticket);
    } else {//desde la view (lista de facturas)
      for (let ticket of invoice_tickets) {
        //refund
        var _refund_reason = '';
        if (ticket.refund_reason) {
          _refund_reason = ticket.refund_reason;
        } else {
          _refund_reason = '';
        }
        _ticket = {
          'number': ticket.number + " (" + this.globals.timestampToDate(ticket.date) + ")" + ' ' + _refund_reason,
          'amount': this.cp.transform(ticket.amount, this.globals.user_currency, true, '0.2-2', 'es'),
          'tip': this.cp.transform(ticket.tip, this.globals.user_currency, true, '0.2-2', 'es'),
        }
        //tips
        if (ticket.tip) {
          _tips += ticket.tip;
        }
        //taxs
        var taxes_view = this.globals.showIvaProducts(ticket.list);
        _list_taxes.push(taxes_view.taxs);
        //push ticket
        _tickets.push(_ticket);
      }
      _list_taxes = this.globals.combineArraysByTax(_list_taxes, _invoice.rectification || false);
    }
    //add tips to _tickets
    if (_tips > 0) {
      _tickets.push({
        'number': this.translate.instant('general-propinas'),
        'amount': this.cp.transform(Math.abs(_tips) * (_tips < 0 ? 1 : -1), this.globals.user_currency, true, '0.2-2', 'es'),
      });
    }
    //format taxes
    for (let tax of _list_taxes) {
      tax.tax = tax.tax + "%";
      tax.total_iva = this.cp.transform(tax.total - tax.total_without_iva, this.globals.user_currency, true, '0.2-2', 'es');
      tax.total = this.cp.transform(tax.total, this.globals.user_currency, true, '0.2-2', 'es');
      tax.total_without_iva = this.cp.transform(tax.total_without_iva, this.globals.user_currency, true, '0.2-2', 'es');
    }
    //LOGO
    var logo_format;

    if (!this.globals.logo_url) {
      logo_format = '';
    } else {
      await this.globals.logo_url.subscribe(data => {
        logo_format = data;
      });
    }

    //JSON.stringify
    var customer = JSON.stringify(_customer);
    var restaurant = JSON.stringify(_restaurant);
    var tickets = JSON.stringify(_tickets);
    var invoice = JSON.stringify(_invoice);
    var list_taxes = JSON.stringify(_list_taxes);

    //option download/email
    const params = new HttpParams()
      .set('customer', customer)
      .set('restaurant', restaurant)
      .set('tickets', tickets)
      .set('invoice', invoice)
      .set('taxes', list_taxes)
      .set('logo', logo_format);

    if (option === 'download') {
      this.http.post(this.globals.api_path + 'invoice/download_pdf', params, {})
        .subscribe(res => {
          if (this.globals.so_mobile) {
            window.location.assign(String(res['file']));
          } else {
            window.open(String(res['file']), '_blank');
          }
        });
    } else {
      //if email (para poder enviar el mail)
      if (customer_raw.email) {
        let loadingPopup = this.loadingCtrl.create({
          spinner: 'crescent',
          content: this.translate.instant('general-enviando-email'),
        });
        loadingPopup.present();

        this.http.post(this.globals.api_path + 'invoice/sendby_email_pdf',
          params, {})
          .subscribe(res => {
            loadingPopup.dismiss();
            let toast_ok = this.toastCtrl.create({
              message: this.translate.instant('general-email-enviado-correctamente'),
              duration: 3000,
              position: 'bottom'
            });
            toast_ok.present();
          }, error => {
            loadingPopup.dismiss();
            let toast_error = this.toastCtrl.create({
              message: this.translate.instant('general-problema-al-enviar-correo'),
              duration: 3000,
              position: 'bottom'
            });
            toast_error.present();

          });


      } else {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('general-cliente-no-email'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }
    }
  }

  async getIfCustomerHasPendingInvoice(customer_uid) {
    var _state = true;
    const invoicesRef = this.firestore.collection('invoices');
    await invoicesRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .where('customer_uid', '==', customer_uid)
      .where('invoice_confirm', '==', false)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          _state = false;
        });
      });
    return _state;
  }


  get_invoices_done: boolean = false;
  invoices_array_tmp: any = [];
  list_invoices_array: any = [];
  invoices_array_filtered: any = [];
  invoices_searchbar_text: any = '';

  async getNodeInvoices() {
    this.get_invoices_done = false;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    await this.http.post(this.globals.analytics_path + 'paginate/invoices', params, {})
      .subscribe(async res => {

        this.invoices_array_tmp = res['list'];

        if (this.invoices_array_tmp.length != 0) {
          this.getListInvoicesMinMax();
        } else {
          this.get_invoices_done = true;
        }

      });
  }

  getListInvoicesMinMax() {
    this.get_invoices_done = true;
    this.list_invoices_array = this.invoices_array_tmp;
    this.invoices_array_filtered = this.invoices_array_tmp;
    this.invoicesSearch(this.invoices_searchbar_text);
  }

  invoicesSearch(value) {
    if (value) {
      this.invoices_array_filtered = this.list_invoices_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.invoices_array_filtered = this.list_invoices_array;
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/invoices/services.ts